import { useAuthStep } from "@/hooks/useAuthStep";
import { useCommunication } from "@/lib/CommunicationWrapper";
import { trackEvent } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { CalendarSyncGate } from "./CalendarSyncGate";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { CLOUDFLARE_URL } from "@/lib/config";



export const TrySync = () => {

    const { setAuthStep, ageBand, token, uuid } = useAuthStep();
    const [waiting, setWaiting] = useState(false);

    const [allowSkip, setAllowSkip] = useState(false);

    const { authenticatedFetch, updateOptions } = useCommunication();


    const confirmSignup = useCallback(async () => {

        try {
            const response = await authenticatedFetch(`${CLOUDFLARE_URL}/user/confirm-signup`, {
                method: "POST",
                body: {
                    "dob": ageBand,
                }
            });

            if (!response.ok) {
                trackEvent("signup_claim_trial_failed", { "distinct_id": uuid, "error": response.statusText });
            }
        } catch (error) {
        } finally {
            setWaiting(false);
        }
    }, [token]);

    return (
        <div className="flex flex-col h-full mb-[30px] px-[30px]">
            <div>
                <h1 className="text-2xl font-semibold text-black mb-[5px]">Never miss a deadline again</h1>
            </div>
            <div className="flex-1 flex flex-col gap-[10px]">
                <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ""}>
                    <CalendarSyncGate />
                </GoogleOAuthProvider>
            </div>
        </div>
    )
}